import { Chip, Input } from '../../components/ui.js';
import { denPlus, formatTermin } from './datum.js';

/**
 * Výběr termínu pro terén (UX audit A3.2 / TOP 10): rychlé volby
 * Zítra · Pozítří · Za týden + zobrazený český text „st 8. 7. 2026"; nativní
 * picker zůstává jako „jiné datum" (50+ nesmí luštit mm/dd/yyyy).
 * Hodnota je den ve formátu YYYY-MM-DD.
 */
export function DatumVolba({
  popisek = 'Termín',
  hodnota,
  onZmena,
}: {
  popisek?: string;
  hodnota: string;
  onZmena: (den: string) => void;
}) {
  const volby: { text: string; den: string }[] = [
    { text: 'Zítra', den: denPlus(1) },
    { text: 'Pozítří', den: denPlus(2) },
    { text: 'Za týden', den: denPlus(7) },
  ];

  return (
    <div className="flex flex-col gap-2">
      <span className="text-base font-semibold">{popisek}</span>
      <div className="flex flex-wrap gap-2">
        {volby.map((v) => (
          <Chip key={v.text} vybrany={hodnota === v.den} onClick={() => onZmena(v.den)}>
            {v.text}
          </Chip>
        ))}
      </div>
      <label className="flex flex-col gap-1">
        <span className="text-sm text-text-secondary">jiné datum</span>
        <Input
          type="date"
          aria-label={`${popisek} — jiné datum`}
          value={hodnota}
          onChange={(e) => onZmena(e.target.value)}
        />
      </label>
      {hodnota ? (
        <p className="text-base font-semibold text-text-primary">{formatTermin(hodnota)}</p>
      ) : null}
    </div>
  );
}
